import { FormDialogSubmitHandler } from '@aibees/shared/components';
import { Member } from '@aibees/shared/definition';
import { notificationIconMap } from '@aibees/shared/features/notifications/config';
import { useNotify } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { useUpdateWorkspace } from '@aibees/shared/workspace';
import { random } from 'lodash-es';
import { memo } from 'react';
import { useEditMember } from '../../api/use-edit-member';
import { EditRoleForm } from '../edit-role-form';
import { config, scheme } from './config';
import { useEditRoleDialogContext } from './context';
import * as Styled from './styles';
import type { EditRoleDialogProps as Props } from './types';

export const EditRoleDialog = memo(({ className, item, onClose }: Props) => {
  const notify = useNotify();
  const api = useEditMember(item.user?.id);
  const updateWorkspace = useUpdateWorkspace();
  const { submitButtonDisabled } = useEditRoleDialogContext();

  const handleSubmit: FormDialogSubmitHandler<Member> = (data, e) => {
    e.startProgress();
    api
      .mutateAsync({ member: { type: data.type, user: item.user } })
      .then((workspace) => {
        updateWorkspace(workspace);
        e.toggle();
        notify.complete(
          'Role updated!',
          `<b>${item.user?.firstName} ${item.user?.lastName}’s</b> account role updated to admin.`,
          random(1, 100),
          {
            icon: notificationIconMap.UserManagement!,
          }
        );
      })
      .catch(() => {
        e.endProgress();
      });
  };

  return (
    <Styled.Wrapper
      className={classnames('EditRoleDialog', className)}
      {...config}
      scheme={scheme}
      defaultOpen
      defaultValues={{ type: item.type }}
      onClose={onClose}
      onSubmit={handleSubmit}
      submitButtonProps={{ disabled: submitButtonDisabled.value }}
      maxWidth="xs"
      fullWidth
    >
      <EditRoleForm item={item} />
    </Styled.Wrapper>
  );
});

EditRoleDialog.displayName = 'EditRoleDialog';
